import React, { useState, useEffect, useRef } from "react";
import {
  Input,
  Table,
  Tag,
  Button,
  message,
  Form,
  Row,
  Select,
  DatePicker,
  Col,
  Modal,
  Card,
  Radio,
} from "antd";
import Service from "../../service";
import moment from "moment";
import { showAuthLoader, hideAuthLoader } from "../../appRedux/actions/Auth";
import { useDispatch, useSelector } from "react-redux";
import { getResource } from "../../util/getResourcePermission";
import config from "../../permission/config.json";

const { Option } = Select;
const Search = Input.Search;
const KarmaApprovelAdmin = (props) => {
  const { history } = props;

  const params = new URLSearchParams(window.location.search);
  const leave_type = params.get("leave_type");
  const filter = params.get("leave_status");
  // const filter = history.location.state?.filter;
  const [eventApiData, setEventApiData] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
  });
  const importRef = useRef(null);
  const searchRef = useRef();
  const [searchText, setSearchText] = useState("");
  const [val, setVal] = useState(filter ? filter : "All");
  const [seachEnabled, setSearchEnabled] = useState(false);
  const [deptData, setDeptData] = useState([]);
  const [IsModalView, setIsModalView] = useState(false);
  let [filterData, setFilterData] = useState([]);
  const [eventTypeApiData, setEventTypeApiData] = useState([]);
  const [eventType, setEventType] = useState(null);
  const [departmentList, setDepartmentList] = useState([]);
  const [positionlist, setpositionList] = useState([]);
  const [eventTypeList, setEventTypeList] = useState([]);
  const [time_hours, setTime_hours] = useState([10, 0, 19, 0]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [focusedDate, setFocusedDate] = useState();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [empdropdown, setEmpDropdown] = useState([]);
  const [waffleNmae, setwaffleName] = useState([]);
  const [waffleNmaeModal, setwaffleNameModal] = useState(false);

  const [emplyeeName, setEmployeeName] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [isVisible, setisVisible] = useState(false);
  const [totalRecord, setTotalRecord] = useState(null);
  const [setClrFtr, setsetClrFtr] = useState(false);
  const [emplyeeNameTxt, setEmployeeNameTxt] = useState("");

  const filterFormRef = useRef();

  let { authUser } = useSelector(({ auth }) => auth);

  const onChange = (e) => {
    setVal(e.target.value);
  };

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
    },
  };

  const onSelectChange = (newSelectedRowKeys) => {
    // Ensure only unique keys are stored
    setSelectedRowKeys([...new Set(newSelectedRowKeys)]);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    getCheckboxProps: (record) => ({
      disabled: record?.status !== "pending", // 🔹 Disable Non-Pending Rows
    }),
  };

  const onReset = () => {
    form.resetFields();
    // setFileList([]);
  };
  const onCancel = () => {
    if (props.history.length > 1) {
      props.history.goBack();
    } else {
      props.history.push("/event");
    }
  };
  const filterEmp = async (values) => {
    console.log(
      "🚀 ~ file: LeaveApproval.js:101 ~ filterEmp ~ values:",
      values
    );
    setFilterData(values);
    setIsModalView(!IsModalView);
  };

  const resetSearchFilter = (e) => {
    const keyCode = e && e.keyCode ? e.keyCode : e;
    switch (keyCode) {
      case 8:
        if (searchRef.current.state?.value?.length <= 1 && seachEnabled) {
          searchRef.current.state.value = "";
          setSearchText("");
          setSearchEnabled(false);
        }
        break;
      case 46:
        if (searchRef.current.state?.value?.length <= 1 && seachEnabled) {
          searchRef.current.state.value = "";
          setSearchText("");
          setSearchEnabled(false);
        }
        break;
      default:
        break;
    }
  };
  const onSearch = (value) => {
    setSearchText(value);
    setPagination({ ...pagination, current: 1 });
  };
  const handleTableChange = (page, filters, sorter) => {
    setPagination({ ...pagination, ...page });
    // karmaRewardGet()
    // karmaRewardGet()
  };

  // const handleTableChange = (pagination, filters, sorter) => {
  //     fetchData({
  //       page: pagination.current,
  //       limit: pagination.pageSize,
  //       search: filters?.search || "",
  //       empCode: filters?.empCode || "",
  //       startDate: filters?.startDate || "",
  //       endDate: filters?.endDate || "",
  //     });
  //   };

  console.log(pagination, "pagination");

  let { _id } = JSON.parse(localStorage.getItem("user_data"));

  useEffect(() => {
    const unloadListener = (e) => {
      if (e.currentTarget.performance.navigation.type === 1) {
        history.replace({});
      }
    };
    window.addEventListener("beforeunload", unloadListener);
    return () => {
      history.replace({});
      window.removeEventListener("beforeunload", unloadListener);
    };
  }, []);

  useEffect(() => {
    form.setFieldsValue("leave_status", val);
  }, [val]);

  const columns = [
    {
      title: "Employee code",
      dataIndex: "employee_code",
      key: "employee_code",
      render: (text, record, index) => {
        const event = record.empCode;
        return <span style={ { textTransform: "capitalize" } }>{ event }</span>;
      },
    },
    {
      title: "Employee name",
      dataIndex: "employee_name",
      key: "employee_name",
      render: (text, record, index) => {
        const event = record.empName;
        return <span style={ { textTransform: "capitalize" } }>{ event }</span>;
      },
    },
    //   {
    //     title: "Reward Name",
    //     dataIndex: "reward_name",
    //     key: "reward_name",

    //     render: (text, record, index) => {
    //       // const event = record.leave_approval_date
    //       //   ? moment(record.leave_approval_date).format("DD-MMM-YYYY")
    //       //   : "-----";
    //       return <span style={ { textTransform: "capitalize" } }>{record?.rewardName}</span>;
    //     },
    //   },
    {
      title: "Waffle Count",
      dataIndex: "reward_point",
      key: "reward_point",
      render: (text, record, index) => {
        // const event = record.application_date
        //   ? moment(record.application_date).format("DD-MMM-YYYY")
        //   : "-----";
        return (
          <span style={ { textTransform: "capitalize" } }>
            { record?.waffle_amount_selected
              ? record?.waffle_amount_selected
              : 0 }
          </span>
        );
      },
    },
    // {
    //   title: "Employee Remaining Waffle",
    //   dataIndex: "employee_remaining_balance",
    //   key: "employee_remaining_balance",
    //   width: "20%",
    //   render: (text, record, index) => {
    //     const event = record.empRemainingBalance;
    //     return <span style={ { textTransform: "capitalize" } }>{ event }</span>;
    //   },
    // },

    // {
    //   title: "Reward",
    //   dataIndex: "reward",
    //   key: "leave",
    //   render: (text, record, index) => {
    //     let Leave =
    //       record?.leave == "paid_leave"
    //         ? "Leave"
    //         : record?.leave == "birthday_leave"
    //           ? "Birthday Leave"
    //           : record?.leave == "paternity_leave"
    //             ? "Paternity Leave"
    //             : record?.leave == "maternity_leave"
    //               ? "Maternity Leave"
    //               : record?.leave == "compoff_leave"
    //                 ? "Compoff Leave"
    //                 : record?.leave == "unpaid_leave"
    //                   ? "LWP" :
    //                   record?.leave == "optional_leave" ? "Optional Holiday Leave" : "Flexy Leave";
    //     return <span style={ { textTransform: "capitalize" } }>{ Leave }</span>;
    //   },
    // },
    // {
    //   title: "From Date",
    //   dataIndex: "from_date",
    //   key: "from_date",
    //   render: (text, record, index) => {
    //     const event = record.from_date
    //       ? moment(record.from_date).format("DD-MMM-YYYY")
    //       : "-----";
    //     return <span style={ { textTransform: "capitalize" } }>{ event }</span>;
    //   },
    // },
    // {
    //   title: "Period",
    //   dataIndex: "period",
    //   key: "period",
    //   render: (text, record, index) => {
    //     let leaveData =
    //       record?.leave === "flexy_leave"
    //         ? record?.no_of_hours
    //         : record?.no_of_days;
    //     let daysAndHours = record?.leave === "flexy_leave" ? "hours" : "day(s)";
    //     return <span>{ leaveData + " " + daysAndHours }</span>;
    //   },
    // },
    // {
    //   title: "Leave Reason",
    //   dataIndex: "leave_reason",
    //   key: "leave_reason",
    //   render: (text, record, index) => {
    //     const event = record.reason;
    //     return <span style={ { textTransform: "capitalize" } }>{ event }</span>;
    //   },
    // },
    // {
    //   title: "Attachments",
    //   dataIndex: "files",
    //   key: "files",
    //   render: (text, record, index) => {
    //     if (record?.files === "" || record?.files === null || record?.files === undefined) {
    //       <span>-</span>;
    //     }
    //     return (
    //       <span>
    //         <a
    //           href={ `${Service.Server_Base_URL}/uploads/LeaveFiles/${record?.files}` }
    //           target="_blank"
    //           rel="noopener noreferrer"
    //         >
    //           { record?.files }
    //         </a>
    //       </span>
    //     );
    //   },
    // },
    {
      title: "Requested Date",
      dataIndex: "reward_point",
      key: "reward_point",
      render: (text, record, index) => {
        // const event = record.application_date
        //   ? moment(record.application_date).format("DD-MMM-YYYY")
        //   : "-----";
        return (
          <span style={ { textTransform: "capitalize" } }>
            { moment(record?.createdAt).format("DD MMM YYYY") }
          </span>
        );
      },
    },
    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   key: "status",
    //   render: (text, record, index) => {
    //     // Function to capitalize the first letter of the status
    //     const capitalize = (str) =>
    //       str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : "";

    //     const status = capitalize(record?.status);

    //     // Assign colors based on status
    //     const color =
    //       record?.status === "pending"
    //         ? "processing"
    //         : record?.status === "approved"
    //           ? "success"
    //           : record?.status === "rejected"
    //             ? "red"
    //             : "error";

    //     return status ? <Tag color={ color }>{ status }</Tag> : null;
    //   },
    // },
    // {
    //   title: "Cancel Date",
    //   dataIndex: "cancel_date",
    //   key: "cancel_leave_details_array",
    //   render: (text, record, index) => {
    //     const date = record?.cancel_leave_details_array?.map((item) => {
    //       // console.log(item,"item")
    //       if (item?.status !== "Not-Applied") {
    //         return (
    //           <p className="date-cancel">
    //             {moment(item?.particular_date).format("DD-MMM-YYYY")}
    //           </p>
    //         );
    //       } else {
    //         console.log("error");
    //       }
    //     });

    //     return <div>{date}</div>;
    //   },
    // },
    // {
    //   title: "Approved",
    //   dataIndex: "status",
    //   key: "status",
    //   render: (text, record, index) => {
    //     if (record.leave_status == "Accepted") {
    //       const approved_by = record?.is_auto_approved
    //         ? "Automatically"
    //         : "By Manager";
    //       return approved_by ? approved_by : null;
    //     } else {
    //       return " - ";
    //     }
    //   },
    // },
    // {
    //   title: "Cancellation Status",
    //   dataIndex: "status",
    //   key: "status",
    //   render: (text, record, index) => {
    //     const lastRecord =
    //       record?.cancel_leave_details_array[record?.cancel_leave_details_array.length - 1];
    //     if (lastRecord) {
    //       const status = lastRecord.status;
    //       // const color =
    //       // lastRecord.status == "Pending" ||
    //       // lastRecord.status == "Not-Applied"
    //       //     ? "processing"
    //       //     : lastRecord.status == "Accepted"
    //       //     ? "success"
    //       //     : "error";
    //       let color;
    //       if (lastRecord.status == "Pending") {
    //         color = 'processing'
    //       }
    //       if (lastRecord.status == "Accepted") {
    //         color = 'success'
    //       }
    //       if (lastRecord.status == "Rejected" || lastRecord.status == "Cancel") {
    //         color = 'error'
    //       }
    //       if (lastRecord.status == "Not-Applied") {
    //         color = 'warning'
    //       }
    //       return lastRecord.status ? <Tag color={ color }>{ status }</Tag> : null;
    //     }

    //   },
    // },
  ];

  const WaffleNameModalOpen = () => {
    setwaffleNameModal(true);
  };
  const handleAccept = async (value) => {
    try {
      dispatch(showAuthLoader());
      console.log(value);

      const reqBody = {
        id: selectedRowKeys,
        status: "approved",
        waffel_reward_name: value?.waffleName,
      };

      const response = await Service.makeAPICall({
        methodName: Service.putMethod,
        api_url: Service.karmaRewardUpdate,
        body: reqBody,
      });
      if (response.data.status == 404) {
        message.error(response.data.message);
      }
      if (response.data) {
        setSelectedRowKeys([]);
        karmaRewardGet();
        response.data.message.toLowerCase().includes("success")
          ? message.success(response.data.message)
          : message.error(response.data.message);
        dispatch(hideAuthLoader());
        closeModal();
      }
      dispatch(hideAuthLoader());
    } catch (error) {
      // dispatch(hideAuthLoader());
      console.log(error);
    }
  };

  const handleReject = async () => {
    try {
      dispatch(showAuthLoader());
      const reqBody = {
        id: selectedRowKeys,
        status: "rejected",
      };

      const response = await Service.makeAPICall({
        methodName: Service.putMethod,
        api_url: Service.karmaRewardUpdate,
        body: reqBody,
      });
      if (response.data.status == 404) {
        message.error(response.data.message);
      }
      if (response.data) {
        message.success(response.data.message);
        karmaRewardGet();

        setSelectedRowKeys([]);
      }

      dispatch(hideAuthLoader());
    } catch (error) {
      // dispatch(hideAuthLoader());
      console.log(error);
    }
  };

  const getFooterDetails = () => {
    return <label>Total Records Count is { totalRecord }</label>;
  };
  const openEventModalView = () => {
    setIsModalView(true);
  };

  const closeEventModalView = () => {
    // setEvent_record(record);
    form.resetFields();
    setIsModalView(!IsModalView);
    // setFilterData([]);
  };
  const readExcel = async (file) => {
    try {
      // dispatch(showAuthLoader());
      const data = new FormData();
      data.append("attachment", file);
      // data.append("org_id", authUser.org_id?._id);
      // data.append("user_id", authUser._id);

      const options = {
        "content-type": "multipart/form-data",
      };
      const response = await Service.makeAPICall({
        methodName: Service.postMethod,
        api_url: Service.importEmpLeaveList,
        body: data,
        options,
      });
      if (response.data && response.data.status === 200) {
        message.success(response.data.message);
      } else {
        message.error(response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const karmaRewardGet = async () => {
    try {
      dispatch(showAuthLoader());
      const formattedStartDate = startDate
        ? moment(startDate).format("YYYY-MM-DD")
        : "";
      const formattedEndDate = endDate
        ? moment(endDate).format("YYYY-MM-DD")
        : "";

      const response = await Service.makeAPICall({
        methodName: Service.getMethod,
        api_url:
          Service.karmaRewardGet +
          `?page=${pagination.current}&limit=${pagination.pageSize}&search=${emplyeeName}&startDate=${formattedStartDate}&endDate=${formattedEndDate}`,
        //  api_url : `${Service.karmaRewardGet}?page=${pagination.current}&limit=${pagination.pageSize}&search=${employeeName}&empCode=${empCode}&startDate=${formattedStartDate}&endDate=${formattedEndDate}`
      });

      if (response.data.data) {
        // message.success(response.data.message);
        setEventApiData(response.data.data);

        setTotalRecord(response.data.totalRecords);

        setisVisible(false);
      }
      dispatch(hideAuthLoader());
    } catch (error) {
      // dispatch(hideAuthLoader());
      console.log(error);
    }
  };
  console.log(eventApiData, "eventApiData");

  const closeModal = (values) => {
    setwaffleNameModal(false);
    form.resetFields(); // Reset form after submission
  };
  const handleFinish = (value) => {
    handleAccept(value);
  };

  // 🔹 Handle Form Submission
  //   const handleSubmit = () => {
  //     onApply({ emplyeeName, startDate, endDate });
  //     onClose(); // Close modal after submission
  //   };

  const handFiltModal = () => {
    setisVisible(true);
  };

  const clearFilter = () => {
    setEmployeeName("");
    setStartDate("");
    setEndDate("");
    setsetClrFtr(true);
    setEmployeeNameTxt("");
    setFilterData([]);

    if (filterFormRef.current) {
      filterFormRef.current.resetFields();
    }
    karmaRewardGet();
  };
  useEffect(() => {
    karmaRewardGet();
  }, [pagination, setClrFtr]);

  const handleFilterChange = (allValues) => {
    const filterValues = { ...allValues };

    // Update state variables that are used in API call
    if (filterValues.employeeName !== undefined) {
      setEmployeeName(filterValues.employeeName);
    }
    if (filterValues.startDate !== undefined) {
      setStartDate(filterValues.startDate);
    }
    if (filterValues.endDate !== undefined) {
      setEndDate(filterValues.endDate);
    }

    setFilterData(filterValues);
    setPagination({ ...pagination, current: 1 });
  };

  return (
    <Card className="employee-card">
      <div className=" inout-header text-left">
        <h2>Waffle Reward </h2>
      </div>
      <Modal
        title="Filter"
        width={ 800 }
        visible={ IsModalView }
        onCancel={ closeEventModalView }
        footer={ [
          <Button
            key="cancel"
            className="delete-btn"
            onClick={ closeEventModalView }
          >
            Cancel
          </Button>,
          <Button
            key="clear"
            className="delete-btn"
            onClick={ () => {
              form.resetFields();
              setVal("All");
              setFilterData([]);
            } }
          >
            Reset
          </Button>,
          <Button
            key="submit"
            type="primary"
            htmlType="submit"
            onClick={ () => form.submit() }
          >
            Apply
          </Button>,
        ] }
      >
        <Form form={ form } layout="vertical" onFinish={ filterEmp }>
          <div className="main-form-wrapper">
            <div className="form-container">
              <div className="form-row">
                <div className="form-col">
                  <div className="form-item">
                    <Form.Item
                      label="Approval From Date"
                      name="approval_from_date"
                    >
                      <DatePicker
                        format="DD-MM-YYYY"
                        className="fulldate-width"
                      // disabledDate={disabledDate}
                      />
                    </Form.Item>
                  </div>
                  <div className="form-item">
                    <Form.Item label="Leave From Date" name="leave_from_date">
                      <DatePicker
                        format="DD-MM-YYYY"
                        className="fulldate-width"
                      // disabledDate={disabledDate}
                      />
                    </Form.Item>
                  </div>
                  <div className="form-item">
                    <Form.Item label="Employee code" name="employee_code">
                      <Select
                        size="large"
                        showSearch
                        filterOption={ (input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={ (optionA, optionB) =>
                          optionA.children
                            .toLowerCase()
                            .localeCompare(optionB.children.toLowerCase())
                        }
                        onChange={ (e) => {
                          let data = empdropdown.filter(
                            (val) => val.emp_code == e
                          );
                          form.setFieldsValue({
                            employee: data[0]?._id,
                          });
                        } }
                      >
                        { empdropdown.map((item, index) => (
                          <Option
                            key={ index }
                            value={ item?.emp_code }
                            className="form-option-capitalize"
                          >
                            { item?.emp_code }
                          </Option>
                        )) }
                      </Select>
                    </Form.Item>
                  </div>
                </div>
                <div className="form-col">
                  <div className="form-item">
                    <Form.Item label="Approval To Date" name="approval_to_date">
                      <DatePicker
                        format="DD-MM-YYYY"
                        className="fulldate-width"
                        disabledDate={ (value) => {
                          return (
                            value < form.getFieldValue("approval_from_date")
                          );
                        } }
                      />
                    </Form.Item>
                  </div>
                  <div className="form-item">
                    <Form.Item label="Leave To Date" name="leave_to_date">
                      <DatePicker
                        format="DD-MM-YYYY"
                        className="fulldate-width"
                        disabledDate={ (value) => {
                          return value < form.getFieldValue("leave_from_date");
                        } }
                      />
                    </Form.Item>
                  </div>
                  <div className="form-item">
                    <Form.Item label="Employee Name" name="employee">
                      <Select
                        size="large"
                        showSearch
                        filterOption={ (input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={ (optionA, optionB) =>
                          optionA.children
                            .toLowerCase()
                            .localeCompare(optionB.children.toLowerCase())
                        }
                        onChange={ (e) => {
                          let data = empdropdown.filter((val) => val._id == e);
                          form.setFieldsValue({
                            employee_code: data[0]?.emp_code,
                          });
                        } }
                      >
                        { empdropdown.map((item, index) => (
                          <Option
                            key={ index }
                            value={ item?._id }
                            className="form-option-capitalize"
                          >
                            { item?.first_name + " " + item?.last_name }
                          </Option>
                        )) }
                      </Select>
                    </Form.Item>
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="form-col-full">
                  <div className="form-item">
                    <Form.Item name="leave_status" initialValue={ val }>
                      <Radio.Group
                        name="radiogroup"
                        onChange={ onChange }
                        value={ val }
                      >
                        <Radio value="All">All</Radio>
                        <Radio value="Pending">Pending</Radio>
                        <Radio value="Accepted">Approved</Radio>
                        <Radio value="Rejected">Rejected</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
      <Card className="main-content-wrapper" >

        <div className="search-wrapper">
          <Search
            placeholder="Search..."
            onSearch={ karmaRewardGet }
            onChange={ (e) => {
              setEmployeeNameTxt(e.target.value);
              setEmployeeName(e.target.value);
            } }
            //   onKeyUp={ resetSearchFilter }
            style={ { width: 200 } }
            className="mr2"
          />
          <div className="filter-btns-wrapper">
            <Form
              ref={ filterFormRef }
              className="filter-btns-wrapper"
              layout="vertical"
              onFinish={ karmaRewardGet }
              onValuesChange={ handleFilterChange }
            >
              {/* Employee Name Input */ }
              <Form.Item name="employeeName">
                <Input
                  value={ emplyeeName }
                  onChange={ (e) => setEmployeeName(e.target.value) }
                  placeholder="Enter employee name"
                />
              </Form.Item>

              {/* Start Date Picker */ }
              {/* <Form.Item name="startDate">
                <DatePicker
                  placeholder="Select start date"
                  value={ startDate ? moment(startDate) : null }
                  onChange={ (date, dateString) => setStartDate(dateString) }
                  format="DD MMM YYYY"
                  style={ { width: "100%" } }
                />
              </Form.Item> */}

              {/* End Date Picker */ }
              {/* <Form.Item name="endDate">
                <DatePicker
                  placeholder="Select end date"
                  value={ endDate ? moment(endDate) : null }
                  onChange={ (date, dateString) => setEndDate(dateString) }
                  format="DD MMM YYYY"
                  style={ { width: "100%" } }
                />
              </Form.Item> */}
            </Form>

            {/* <Button className="filter-btn" type="primary" onClick={ handFiltModal }>Filter</Button> */ }
            <Button className="ant-delete delete-btn" onClick={ clearFilter }>
              Reset
            </Button>
            {/* { getResource(config.RESOURCES.WAFFLE_REWARD, ["update"]) && (
              <>

                <Button
                  className="ant-approve"
                  onClick={
                    WaffleNameModalOpen
                    //  handleAccept
                  }
                  disabled={ !selectedRowKeys.length > 0 }
                >
                  Approve
                </Button>

                <Button
                  className="ant-reject"
                  onClick={ handleReject }
                  disabled={ !selectedRowKeys.length > 0 }
                >
                  Reject
                </Button>


              </>
            ) } */}
          </div>
        </div>

        <Modal
          title="Add Waffle"
          width={ 600 }
          visible={ waffleNmaeModal }
          footer={ null }
          onCancel={ closeModal }
        >
          <Form layout="vertical" form={ form } onFinish={ handleFinish }>
            <Row gutter={ 16 }>
              <Col span={ 24 }>
                <Form.Item
                  label="Waffle Name"
                  name="waffleName"
                  rules={ [
                    { required: true, message: "Please enter the Waffle name" },
                  ] }
                >
                  <Input placeholder="WFH,Leave,etc..." />
                </Form.Item>
              </Col>
            </Row>

            <div style={ { textAlign: "right", display: "flex", gap: "5px" } }>
              <Button onClick={ closeModal } style={ { marginRight: 10 } }>
                Cancel
              </Button>
              <Button type="primary" htmlType="submit">
                Add Waffle
              </Button>
            </div>
          </Form>
        </Modal>
        <div className="main-table-wrapper">

          <Table
            columns={ columns }
            pagination={ {
              showSizeChanger: true,
              ...pagination,
              total: totalRecord,
              showQuickJumper: true,
              showLessItems: false,
            } }
            rowSelection={ rowSelection }
            footer={ getFooterDetails }
            onChange={ handleTableChange }
            dataSource={ eventApiData.map((item, index) => ({
              ...item,
              key: item._id || index, // ✅ Use `_id` if available, else fallback to `index`
            })) }
            rowClassName={ (record) =>
              record?.status !== "pending" ? "disabled-row" : ""
            }
          />
        </div>
      </Card>

      {/* <Table
      columns={columns}
      pagination={{
        showSizeChanger: true,
        ...pagination,
      }}
      rowSelection={rowSelection}
      footer={getFooterDetails}
      onChange={handleTableChange}
      dataSource={eventApiData.map((item, index) => ({
        ...item,
        key: item._id || index, // ✅ Use `_id` if available, else fallback to `index`
      }))}
      rowClassName={(record) =>
        record?.status !== "pending" ? "disabled-row" : ""
      }
    /> */}

      <Modal
        title="Filter"
        visible={ isVisible }
        onCancel={ () => {
          setisVisible(false);
        } }
        footer={ null }
      >
        <Form layout="vertical" onFinish={ karmaRewardGet }>
          {/* Employee Name Input */ }
          <Form.Item label="Employee Name">
            <Input
              value={ emplyeeName }
              onChange={ (e) => setEmployeeName(e.target.value) }
              placeholder="Enter employee name"
            />
          </Form.Item>

          {/* Start Date Picker */ }
          <Form.Item label="Start Date">
            <DatePicker
              value={ startDate ? moment(startDate) : null }
              onChange={ (date, dateString) => setStartDate(dateString) }
              format="DD MMM YYYY"
              style={ { width: "100%" } }
            />
          </Form.Item>

          {/* End Date Picker */ }
          <Form.Item label="End Date">
            <DatePicker
              value={ endDate ? moment(endDate) : null }
              onChange={ (date, dateString) => setEndDate(dateString) }
              format="DD MMM YYYY"
              style={ { width: "100%" } }
            />
          </Form.Item>

          {/* Submit Button */ }
          <Button type="primary" className="filter-btn" htmlType="submit">
            Filter
          </Button>
        </Form>
      </Modal>
    </Card>
  );
};

export default KarmaApprovelAdmin;
